import {
  summaryReducerPrefix,
  insuranceReducerPrefix,
  clearCache,
  goalsReducerPrefix,
  netWorthReducerPrefix,
  refreshPrefix,
  refreshEndpointKeyMap,
} from './MoneyGuideProConstants';
import { SummaryDto, InsuranceDto, GoalsDto, NetWorthDto } from './MoneyGuideProTypes';

export interface MgpState {
  summary?: SummaryDto | null;
  insurance?: InsuranceDto | null;
  goals?: GoalsDto | null;
  netWorth?: NetWorthDto | null;
}

const initialState: MgpState = {};

export const moneyGuidePro = (state = initialState, action) => {
  switch (action.type) {
    case `${summaryReducerPrefix}_SUCCESS`:
      return {
        ...state,
        summary: action.payload || null,
      };
    case `${insuranceReducerPrefix}_SUCCESS`:
      return {
        ...state,
        insurance: action.payload || null,
      };
    case `${goalsReducerPrefix}_SUCCESS`:
      return {
        ...state,
        goals: action.payload || null,
      };
    case `${netWorthReducerPrefix}_SUCCESS`:
      return {
        ...state,
        netWorth: action.payload || null,
      };
    case `${refreshPrefix}_SUCCESS`: {
      const newState = action.payload || {};

      return {
        ...state,
        ...Object.keys(newState).reduce((acc, key) => {
          const slice = refreshEndpointKeyMap[key];
          if (slice) {
            acc[slice] = newState[key];
          }

          return acc;
        }, {}),
      };
    }
    case clearCache:
      return initialState;
    default:
      return state;
  }
};
